import { useQuery } from '@tanstack/react-query'
import apiSetting from '../services/setting'

export function useCompanyPkindev({ id_company, id_bill } = {}) {
  return useQuery({
    queryKey: ['company_pkindev', id_company, id_bill],
    queryFn: () => apiSetting.getCompanyPkindev({ id_company, id_bill }),
    enabled: !!(id_company || id_bill),
    staleTime: 1000 * 60 * 5, // cache 5 นาที
  })
}

